import { render, staticRenderFns } from "./GalleriesSection.vue?vue&type=template&id=a7415f22&"
import script from "./GalleriesSection.vue?vue&type=script&lang=js&"
export * from "./GalleriesSection.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports